/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Reference design opens header submenus (e.g. "Collezioni") on click, not hover.
  // Broadcast's <hover-disclosure> element opens/closes on pointer events (hover);
  // block those in the capture phase so the component's own hover handlers never run.
  ['mouseenter', 'mouseleave', 'mouseover', 'mouseout', 'pointerenter', 'pointerleave', 'pointerover', 'pointerout'].forEach(function(type) {
    document.addEventListener(type, function(e) {
      if (e.target.closest && e.target.closest('hover-disclosure')) e.stopImmediatePropagation();
    }, true);
  });

  // Visibility is driven entirely by our own "js-dropdown-open" class (see
  // custom.css.liquid), never by the component's own is-visible/aria-expanded state,
  // so there's no race between a leftover hover toggle and our click toggle.
  function closeDisclosure(disclosure) {
    var dropdown = disclosure.querySelector('.header__dropdown');
    if (dropdown) dropdown.classList.remove('js-dropdown-open');
  }

  document.addEventListener('click', function(e) {
    var disclosure = e.target.closest ? e.target.closest('hover-disclosure') : null;
    var anyOpen = document.querySelector('.header__dropdown.js-dropdown-open');

    // Fully own this click whenever it's inside a disclosure or a dropdown is
    // currently open (i.e. an "outside click to close" case) — otherwise the
    // theme's own generic outside-click-close handler also reacts to the same
    // click and fights our class, producing a visible open/close flash.
    if (disclosure || anyOpen) e.stopImmediatePropagation();

    document.querySelectorAll('.header__dropdown.js-dropdown-open').forEach(function(openDropdown) {
      var openDisclosure = openDropdown.closest('hover-disclosure');
      if (openDisclosure !== disclosure) openDropdown.classList.remove('js-dropdown-open');
    });

    if (!disclosure) return;

    var topLink = e.target.closest('.navlink--toplevel');
    if (!topLink) return;

    e.preventDefault();
    var dropdown = disclosure.querySelector('.header__dropdown');
    if (!dropdown) return;
    dropdown.classList.toggle('js-dropdown-open');
  }, true);

  // Product page: reference has the "Guida alle taglie" size-guide link inline
  // with the "Taglia:" legend (their app measures the DOM and positions it
  // there). Our size-guide is a separate block below the variant picker, and
  // a pure-CSS offset can't reliably reach the legend row since its vertical
  // position varies per product (title length, number of trust badges, etc).
  // Move the popup block into the legend itself once, on load.
  //
  // Reference never shows a size guide at all when a product has no real
  // size option (single "Default Title" variant, or an option like "Colore"
  // with no size dimension) -- hiding it also removes the ~16px
  // .block-padding gap it was providing between the trust-line block and
  // the add-to-cart button, so that gap gets restored on whichever block
  // ends up last before the button.
  function hidePopupAndRestoreSpacing(popup) {
    var prev = popup.previousElementSibling;
    if (prev) {
      prev.style.marginBottom = '16px';
    }
    popup.style.display = 'none';
  }
  // Same, but for when the popup's previous sibling is the variants block
  // itself (product has options, just none of them a size) -- that block
  // already carries its own spacing before the button, so no compensation
  // is needed there; adding 16px on top of it left a ~115px gap.
  function hidePopup(popup) {
    popup.style.display = 'none';
  }

  var sizeKeywords = ['taglia', 'size', 'numero', 'misura'];
  var variantLinesBlocks = document.querySelectorAll('.product__block--lines.product__form__holder');
  if (variantLinesBlocks.length) {
    variantLinesBlocks.forEach(function(variantsBlock) {
      var next = variantsBlock.nextElementSibling;
      if (!next || next.tagName !== 'POPUP-COMPONENT') return;

      // A product can have multiple options (e.g. Colore + Taglia), each
      // with its own separate .radio__legend -- grabbing just the first
      // one is wrong whenever Colore is listed before Taglia. Match the
      // legend whose own label is actually about size.
      var legends = variantsBlock.querySelectorAll('.radio__legend');
      var sizeLegend = null;
      legends.forEach(function(legend) {
        if (sizeLegend) return;
        var nameEl = legend.querySelector('.radio__legend__option-name');
        var label = (nameEl ? nameEl.textContent : legend.textContent).trim().toLowerCase();
        if (sizeKeywords.some(function(k) { return label.indexOf(k) !== -1; })) {
          sizeLegend = legend;
        }
      });

      if (sizeLegend) {
        sizeLegend.appendChild(next);
      } else {
        hidePopup(next);
      }
    });
  } else {
    document.querySelectorAll('.form__width > popup-component').forEach(hidePopupAndRestoreSpacing);
  }

  // Product page: reference's sticky bottom bar has inline pickers (one per
  // option -- e.g. Colore + Taglia) that add to cart directly instead of
  // Broadcast's default "Configure" (scroll-to-form) button. Rather than
  // duplicating variant-change/cart logic, drive the real variant picker
  // from the bar's own selects and reuse its own "Guida alle taglie" popup
  // -- both already work correctly. Each select is scoped to its own
  // option position (data-cart-bar-option-index / data-index="option1",
  // "option2", ...) rather than matched by value alone, since two
  // different options (e.g. a color and a size) could coincidentally
  // share the same value string.
  document.querySelectorAll('[data-cart-bar-variant-select]').forEach(function(cartBarSelect) {
    cartBarSelect.addEventListener('change', function() {
      var optionIndex = cartBarSelect.getAttribute('data-cart-bar-option-index');
      var radio = document.querySelector(
        '.product__form__holder [data-single-option-selector][data-index="' + optionIndex + '"][value="' + CSS.escape(cartBarSelect.value) + '"]'
      );
      if (!radio) return;
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      radio.dispatchEvent(new Event('input', { bubbles: true }));
    });
  });

  var cartBarGuideProxy = document.querySelector('[data-cart-bar-guide-proxy]');
  if (cartBarGuideProxy) {
    cartBarGuideProxy.addEventListener('click', function() {
      var trigger = document.querySelector('.product__form__holder popup-component [data-popup-open]');
      if (trigger) trigger.click();
    });
  }

  // "La nostra comunità" photo carousel (and, via the shared .vt- classes,
  // the cart-drawer upsell carousel too): native scroll-snap track,
  // prev/next buttons scroll by one card, dots reflect + set the active
  // card. Cart-drawer content is replaced wholesale on every add/remove
  // (AJAX cart), so this init is re-run on theme:cart:change /
  // theme:cart-drawer:open, guarded by data-carousel-initialized so an
  // already-wired, still-present wrapper (e.g. the testimonials one,
  // untouched by cart updates) isn't double-bound.
  function initVtCarousels() {
    document.querySelectorAll('.vt-slider-wrapper').forEach(function(wrapper) {
    if (wrapper.hasAttribute('data-carousel-initialized')) return;
    wrapper.setAttribute('data-carousel-initialized', 'true');

    var track = wrapper.querySelector('.vt-slider-container');
    var prev = wrapper.querySelector('.vt-prev');
    var next = wrapper.querySelector('.vt-next');
    var dots = [].slice.call(wrapper.querySelectorAll('.vt-dot'));
    var cards = [].slice.call(track.querySelectorAll('.vt-card'));
    if (!track || !cards.length) return;

    // Tracks the active card explicitly instead of re-deriving it from
    // scroll position on every click -- the old version computed each
    // click's target from the card closest to the viewport CENTER, then
    // asked the track to scroll that card flush to the left edge. For the
    // trailing cards there isn't enough remaining scroll room to do that
    // (there's no space left after the last card), so the browser clamped
    // the scroll short of the target -- which then measured as "closest to
    // a card several steps ahead," so a single click could jump multiple
    // cards, and once clamped at the max scroll position every further
    // click recomputed the same clamped result, appearing stuck.
    var currentIndex = 0;

    function setActiveDot(index) {
      dots.forEach(function(dot, i) {
        dot.classList.toggle('active', i === index);
      });
    }

    function goToIndex(index) {
      index = Math.max(0, Math.min(index, cards.length - 1));
      currentIndex = index;
      cards[index].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      setActiveDot(index);
    }

    function closestIndex() {
      var trackCenter = track.scrollLeft + track.clientWidth / 2;
      var closest = 0;
      var closestDist = Infinity;
      cards.forEach(function(card, i) {
        var cardCenter = card.offsetLeft - track.offsetLeft + card.clientWidth / 2;
        var dist = Math.abs(cardCenter - trackCenter);
        if (dist < closestDist) { closestDist = dist; closest = i; }
      });
      return closest;
    }

    if (prev) prev.addEventListener('click', function() { goToIndex(currentIndex - 1); });
    if (next) next.addEventListener('click', function() { goToIndex(currentIndex + 1); });
    dots.forEach(function(dot, i) { dot.addEventListener('click', function() { goToIndex(i); }); });

    // Manual swipe/drag isn't driven by goToIndex, so keep currentIndex and
    // the dots in sync with wherever the user actually scrolled to.
    var scrollTimeout;
    track.addEventListener('scroll', function() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function() {
        currentIndex = closestIndex();
        setActiveDot(currentIndex);
      }, 100);
    });
    });
  }

  initVtCarousels();
  document.addEventListener('theme:cart:change', initVtCarousels);
  document.addEventListener('theme:cart-drawer:open', initVtCarousels);

  // Collection pages: replace numbered pagination with infinite scroll.
  // Watches the (visually hidden once active) pagination nav as the
  // IntersectionObserver sentinel -- it already sits right after the
  // grid, so no extra markup needed. Fetches one page at a time on
  // scroll rather than loading everything up front, and falls back to
  // the normal pagination links (nothing hidden) if a fetch fails.
  document.querySelectorAll('.grid-outer[data-products-grid]').forEach(function(gridOuter) {
    var nextUrl = gridOuter.getAttribute('data-next-url');
    var grid = gridOuter.querySelector('#CollectionLoop');
    var pagination = gridOuter.querySelector('.pagination-custom');
    if (!nextUrl || !grid || !pagination) return;

    gridOuter.classList.add('js-infinite-scroll');

    var loading = false;

    function loadNextPage() {
      if (loading || !nextUrl) return;
      loading = true;
      gridOuter.classList.add('is-loading');

      fetch(nextUrl)
        .then(function(response) { return response.text(); })
        .then(function(html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('#CollectionLoop');
          var newGridOuter = doc.querySelector('.grid-outer[data-products-grid]');

          if (newGrid) {
            Array.prototype.slice.call(newGrid.children).forEach(function(item) {
              grid.appendChild(item);
            });
          }

          nextUrl = newGridOuter ? newGridOuter.getAttribute('data-next-url') : '';
          if (!nextUrl) observer.disconnect();
        })
        .catch(function() {
          gridOuter.classList.remove('js-infinite-scroll');
          observer.disconnect();
        })
        .finally(function() {
          gridOuter.classList.remove('is-loading');
          loading = false;
        });
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) loadNextPage();
      });
    }, { rootMargin: '400px' });

    observer.observe(pagination);
  });

  // Cart drawer: "reserved for N minutes" urgency banner. Cart-drawer
  // content can be replaced wholesale when Shopify re-renders it after an
  // add/remove (AJAX cart), so this re-queries the live element(s) on
  // every tick instead of caching a reference -- it just self-heals a
  // tick later (at most 1s) instead of going stale. The expiry itself
  // lives in sessionStorage (not tied to any DOM node) so it survives
  // those re-renders untouched and only resets on a new browser session.
  (function() {
    var storageKey = 'reservationTimerExpiry';

    function tick() {
      var banners = document.querySelectorAll('[data-reservation-timer]');
      if (!banners.length) return;

      banners.forEach(function(banner) {
        var valueEl = banner.querySelector('[data-reservation-timer-value]');
        if (!valueEl) return;

        var durationMs = (parseInt(banner.getAttribute('data-duration-minutes'), 10) || 15) * 60 * 1000;
        var expiry = parseInt(sessionStorage.getItem(storageKey), 10);

        if (!expiry || isNaN(expiry) || expiry <= Date.now()) {
          expiry = Date.now() + durationMs;
          sessionStorage.setItem(storageKey, String(expiry));
        }

        var remaining = expiry - Date.now();
        if (remaining <= 0) {
          banner.style.display = 'none';
          return;
        }

        banner.style.display = '';
        var totalSeconds = Math.ceil(remaining / 1000);
        var minutes = Math.floor(totalSeconds / 60);
        var seconds = totalSeconds % 60;
        valueEl.textContent = minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
      });
    }

    tick();
    setInterval(tick, 1000);
  })();

  // The reservation timer sticks just below the theme's own sticky
  // "Carrello" title bar (see the --cart-title-height comment in
  // custom.css.liquid for why) -- keep that height in sync since it can
  // change (item count going from a single digit up, font loading, etc).
  // Re-run on the same cart-update events as the carousel/variant init
  // above, for the same reason: the drawer's markup is replaced wholesale
  // on every add/remove.
  function syncCartTitleHeight() {
    var titleBar = document.querySelector('#cart-drawer .cart-block--top');
    if (!titleBar) return;
    document.documentElement.style.setProperty('--cart-title-height', titleBar.offsetHeight + 'px');
  }

  syncCartTitleHeight();
  document.addEventListener('theme:cart:change', syncCartTitleHeight);
  document.addEventListener('theme:cart-drawer:open', syncCartTitleHeight);

  // Cart drawer "buy more, save more" tier message: the theme's built-in
  // AJAX cart update only patches specific known spans inside the native
  // free-shipping block (its [data-left-to-spend] amount) rather than
  // re-rendering this section on every change -- confirmed live, this
  // block would freeze at whichever item count it was first rendered
  // with otherwise. theme:cart:change already carries the fresh count in
  // event.detail.cartCount (no extra fetch needed there); falls back to
  // /cart.js for theme:cart-drawer:open, which doesn't carry a count.
  function updateTierDiscount(itemCount) {
    var el = document.querySelector('[data-tier-discount]');
    if (!el) return;

    var tier1Qty = parseInt(el.getAttribute('data-tier1-qty'), 10);
    var tier1Pct = parseInt(el.getAttribute('data-tier1-pct'), 10);
    var tier2Qty = parseInt(el.getAttribute('data-tier2-qty'), 10);
    var tier2Pct = parseInt(el.getAttribute('data-tier2-pct'), 10);
    var tier3Qty = parseInt(el.getAttribute('data-tier3-qty'), 10);
    var tier3Pct = parseInt(el.getAttribute('data-tier3-pct'), 10);
    var messageTemplate = el.getAttribute('data-message-template') || '';
    var maxMessageTemplate = el.getAttribute('data-max-message-template') || '';

    var nextQty, nextPct, maxReached = false;
    if (itemCount < tier1Qty) {
      nextQty = tier1Qty; nextPct = tier1Pct;
    } else if (itemCount < tier2Qty) {
      nextQty = tier2Qty; nextPct = tier2Pct;
    } else if (itemCount < tier3Qty) {
      nextQty = tier3Qty; nextPct = tier3Pct;
    } else {
      maxReached = true; nextPct = tier3Pct;
    }

    // Toward the final tier (tier3Qty), not whichever tier is next -- a
    // per-tier-segment percentage would reset to 0% on entering each new
    // tier, reading as the bar randomly emptying and refilling instead
    // of progressing. See the matching comment in the Liquid template.
    var message, percent;
    if (maxReached) {
      message = maxMessageTemplate.replace('||percent||', nextPct);
      percent = 100;
    } else {
      var remaining = nextQty - itemCount;
      message = messageTemplate.replace('||remaining||', remaining).replace('||percent||', nextPct);
      percent = Math.floor((itemCount * 100) / tier3Qty);
    }

    el.classList.toggle('is-success', maxReached);
    el.classList.toggle('is-hidden', itemCount === 0);
    var msgEl = el.querySelector('[data-tier-discount-message]');
    if (msgEl) {
      msgEl.className = maxReached ? 'free-shipping__success-message' : 'free-shipping__default-message';
      msgEl.textContent = message;
    }
    var progressEl = el.querySelector('[data-tier-discount-progress]');
    if (progressEl) progressEl.value = percent;
  }

  document.addEventListener('theme:cart:change', function(e) {
    if (e.detail && typeof e.detail.cartCount === 'number') {
      updateTierDiscount(e.detail.cartCount);
    }
  });
  document.addEventListener('theme:cart-drawer:open', function() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { updateTierDiscount(cart.item_count); })
      .catch(function() {});
  });

  // Cart-drawer upsell carousel: inline variant selects add to cart
  // directly instead of opening the shared quick-add modal (reference has
  // no modal step here). Each card embeds its own product's variant list
  // as JSON, so the matching variant can be resolved locally without a
  // fetch -- only its id needs to reach the card's own add-to-cart form.
  // Re-run on cart updates for the same reason as the carousel init above.
  function initCartUpsellVariants() {
    document.querySelectorAll('[data-cart-upsell-card]').forEach(function(card) {
      if (card.hasAttribute('data-upsell-variants-initialized')) return;
      card.setAttribute('data-upsell-variants-initialized', 'true');

      var selects = [].slice.call(card.querySelectorAll('[data-cart-upsell-option-select]'));
      var variantsScript = card.querySelector('[data-cart-upsell-variants]');
      var hiddenInput = card.querySelector('[data-cart-upsell-variant-id]');
      var addBtn = card.querySelector('[data-add-to-cart]');
      if (!selects.length || !variantsScript || !hiddenInput) return;

      var variants;
      try {
        variants = JSON.parse(variantsScript.textContent);
      } catch (e) {
        return;
      }

      function syncVariant() {
        var selected = selects.map(function(select) { return select.value; });
        var matches = function(variant) {
          return selected.every(function(value, i) { return variant['option' + (i + 1)] === value; });
        };
        var match = variants.filter(function(v) { return v.available; }).find(matches) || variants.find(matches);
        if (!match) return;
        hiddenInput.value = match.id;
        if (addBtn) addBtn.disabled = !match.available;
      }

      selects.forEach(function(select) {
        select.addEventListener('change', syncVariant);
      });
    });
  }

  initCartUpsellVariants();
  document.addEventListener('theme:cart:change', initCartUpsellVariants);
  document.addEventListener('theme:cart-drawer:open', initCartUpsellVariants);

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
